export default {
  getProductFeature: (state) => state.productFeature,
};
